var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'widget', 'style1', _vm.bg ]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('h1',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.focus))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }